import AppProvider from "@atlaskit/app-provider";
import type {ComponentProps} from "react";

export function AnankeAppProvider(props: ComponentProps<typeof AppProvider>) {
    return <AppProvider {...props} />;
}
